import { useState, useEffect } from "react";
import { TiPencil } from "react-icons/ti";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import RequestModal from "./components/RequestModal";
import DateRangeSelector from "../../Common/DateRangeElement";
import AddCompany from "./components/AddCompany";
import { DELETE_POP_UP, downloadCsv, formatDate, formatListItems, isValidObject, reverseDateFormat } from "../../utils";
import { getCompaniesRq } from "../../actions/companies";
import { appApis, headerColumn } from "../../constants";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useApiRequest } from "../../hooks/useApiRequest";
import { MdOutlineFileDownload } from "react-icons/md";
import SearchableDropdown from "../../Common/SearchDropdown";
import { getInstallers } from "../../actions/installer";
import moment from "moment";


const CompanyRequest = () => {
    const [state, setState] = useState({
        loading: false,
        request: false,
        addCompany: false,
        companyData: {},
        companiesList: [],
        installerList: [],
        current: 1,
        total: 1,
        search: "",
        installer: "",
        firstCall: false,
    });
    const { request: makiApiRequest, loading: deleteRequest } = useApiRequest();
    const { request: downloadRequest, loading: isdownloading } = useApiRequest();
    const { companiesList, search, request, total, current, addCompany, loading, companyData, installer, installerList, installerId, firstCall } = state;

    const getCompanies = (date, pageIndex = null) => {
        setState(prev => ({ ...prev, loading: true, firstCall: true }))
        let query = `?page=${pageIndex ? pageIndex : current}&limit=200`;
        if (search) query = `${query}&keyword=${search}`;
        if (installer) query = `${query}&installerId=${installerId}`;
        if(date?.startDate && date?.endDate) query =`${query}&startDate=${reverseDateFormat(date?.startDate ?? "")}&endDate=${reverseDateFormat(date?.endDate ?? "")}`;
        
        getCompaniesRq(query).then(response => {
            setState(prev => ({ ...prev, total: response?.data?.data?.total ?? 1, companiesList: response?.data?.data?.filteredLogs || [] }))
        }).catch(ex => { }).finally(() => {
            setState(prev => ({ ...prev, loading: false }))
        })
    }

    const removeRequest = (id) => {
        if (id) {
            DELETE_POP_UP(() => makiApiRequest({
                method: "DELETE",
                url: `api/v1/companies/request-log/${id}`,
                onSuccess: () => paginationAction(1)
            }))
        }
    }

    const downloadData = () => {
        downloadRequest({
            url: appApis.downloadRequestData,
            showToast: false,
            onSuccess: (responseData) => {
                downloadCsv(responseData ?? "", "companies-request");
            }
        })
    }

    const getInstallerList = () => {
        getInstallers().then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, installerList: formatListItems(data?.installers ?? [], "installerId", "name") }));
            }
        }).catch(ex => { });
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getCompanies(null, pageIndex);
    }

    useEffect(() => {
        const startdateupdate = moment().subtract(29, 'days').format("DD-MM-YYYY");
        const enddateupdate = moment().format("DD-MM-YYYY");
        getCompanies({ startDate: startdateupdate, endDate: enddateupdate });
        getInstallerList();
    }, [])

    useEffect(() => {
        if(firstCall) paginationAction(1);
    }, [search, installer])


    return <div className="company-container">
        <SearchBox placeholder="Search here..." value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} className="mb-3" />
        <TableComponent col={4} breakPoint="lg" current={current} total={total} tableLoading={loading} paginationAction={paginationAction} title={"Company's Request"} headers={headerColumn.companiesRq} data={companiesList} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.companyName ?? "-"}</td>
            <td>{tdData?.requestType ?? "-"}</td>
            <td>{tdData?.Vehicle?.vehicleRegno ?? "-"}</td>
            <td>{tdData?.gpsImei ?? "-"}</td>
            <td>{tdData?.simNumber ?? "-"}</td>
            <td>{tdData?.installer ?? "-"}</td>
            <td>{formatDate(tdData?.requestActionDate ?? "")}</td>
            <td className={`text-${tdData?.status ? "success" : "warning"}`}>{tdData?.status ? "Completed" : "Pending"}</td>
            <td>
                {/* <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => setState(prev => ({ ...prev, request: true, companyData: tdData }))} variant="btn-outline-edit" loading={false} /> */}

                <ButtonElement text={<RiDeleteBin5Line size={20} />} cssClass="more-radius px-4" onClick={() => removeRequest(tdData?.requestLogId ?? 0)} variant="btn-delete-icon" loading={deleteRequest} />
            </td>
        </tr>} FilterComponent={<>
            <div>
                <SearchableDropdown
                    placeholder={"Installer Name"}
                    value={installer}
                    error={false}
                    options={installerList}
                    onSelect={(value) => setState(prev => ({ ...prev, installer: value?.name ?? "", [`installerId`]: value?.id ?? null }))}
                />
            </div>
            <DateRangeSelector updateRange={getCompanies} />
            <ButtonElement loading={isdownloading} text={<MdOutlineFileDownload fontSize={24} />} cssClass="small-radius me-1 mb-1" onClick={downloadData} variant="btn-outline-grey" />
            <ButtonElement text={"Add Request"} cssClass="small-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, request: true }))} variant="btn-black" loading={false} />
        </>} />

        {request ? <RequestModal show={request} defaultData={companyData} hideModal={() => setState(prev => ({ ...prev, request: false }))} sucessAction={() => paginationAction(1)} showCompany={() => setState(prev => ({ ...prev, request: false, addCompany: true }))} /> : null}

        {addCompany ? <AddCompany show={addCompany} hideModal={() => setState(prev => ({ ...prev, addCompany: false }))} /> : null}
    </div>
}

export default CompanyRequest;